import { CSSProperties } from 'react';

export const MAX_CELLS_TO_RENDER = 1000;

export const LOADING_SX = {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	width: '100%',
	height: '100%',
	minHeight: '400px',
};

export const CONTAINER_SX = {
	width: '100vw',
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: 'white',
};

export const TABS_SX = {
	borderBottom: 1,
	borderColor: 'divider',
	backgroundColor: '#f5f5f5',
};

export const CONTENT_SX = {
	flex: 1,
	overflow: 'auto',
	padding: '20px',
};

export const TABLE_WRAPPER_SX = {
	display: 'inline-block',
	minWidth: '100%',
};

export const TABLE_STYLE: CSSProperties = {
	borderCollapse: 'collapse',
	fontSize: '14px',
	backgroundColor: 'white',
	boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
};

export const getCellStyle = (rowIndex: number, isBold: boolean) => ({
	border: '1px solid #ddd',
	padding: '8px 12px',
	textAlign: 'left' as const,
	fontWeight: isBold ? 'bold' : 'normal',
	backgroundColor: rowIndex === 0 ? '#f5f5f5' : 'white',
	whiteSpace: 'nowrap' as const,
	minWidth: '80px',
});
